import type { TFrameOptions, IRunPlan, TVerification } from '../types';

export default function (verification: TVerification, runPlan: IRunPlan, frameOptions: TFrameOptions) {
  if (!frameOptions.remote_view) {
    throw 'frame settings: `remote_view` is required';
  }

  if (!frameOptions.environment) {
    throw 'frame settings: `environment` is required';
  }
}
